import { render } from "./NavTop.vue?vue&type=template&id=2b5aa0ee&scoped=true"
import script from "./NavTop.vue?vue&type=script&lang=js"
export * from "./NavTop.vue?vue&type=script&lang=js"

import "./NavTop.vue?vue&type=style&index=0&id=2b5aa0ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b5aa0ee"]])

export default __exports__